import { useEffect } from "react";

const VisioptTrackingComponent = ({ siteId, pageId }) => {
  useEffect(() => {
    // console.log(window.location.pathname);
    const visiopt_code = () => {
      var Visi_domain = "https://visiopt.com";
      var visi_wid = siteId,
        visi_pid = pageId,
        visi_flicker_time = 0,
        visi_flicker_element = "html",
        c = false,
        d = document;

      var visi_fn = {
        begin: function () {
          var a = d.getElementById("visi_flicker");
          if (!a) {
            var a = d.createElement("style"),
              b = visi_flicker_element
                ? visi_flicker_element +
                  "{opacity:0!important;background:none!important;}"
                : "",
              h = d.getElementsByTagName("head")[0];
            a.setAttribute("id", "visi_flicker");
            a.setAttribute("type", "text/css");
            if (a.styleSheet) {
              a.styleSheet.cssText = b;
            } else {
              a.appendChild(d.createTextNode(b));
            }
            h.appendChild(a);
          }
        },
        complete: function () {
          c = true;
          var a = d.getElementById("visi_flicker");
          if (a) {
            a.parentNode.removeChild(a);
          }
        },
        completed: function () {
          return c;
        },
        pack: function (a) {
          var b = d.createElement("script");
          b.src = a;
          b.type = "text/javascript";
          b.onerror = function () {
            visi_fn.complete();
          };
          d.getElementsByTagName("head")[0].appendChild(b);
        },
        init: function () {
          visi_fn.begin();
          setTimeout(function () {
            visi_fn.complete();
          }, visi_flicker_time);
          this.pack(
            Visi_domain +
              "/client/js_test/test." +
              visi_wid +
              "." +
              visi_pid +
              ".js"
          );
          return true;
        },
      };
      visi_fn.init();
    };

    visiopt_code();

    return () => {
      // Cleanup logic if needed
    };
  }, [siteId, pageId]);

  return null; // This component doesn't render anything visible
};

export default VisioptTrackingComponent;
